// extracted by mini-css-extract-plugin
module.exports = {"close":"GlobalPopupCross_close__2Cosp","closeOne":"GlobalPopupCross_closeOne__2Mlnb","closeTwo":"GlobalPopupCross_closeTwo__1D7aL"};